import Grid, { type GridProps } from '@mui/material/Grid';

import { ViewportSize } from '@/styles/viewportSize';

import useStyles from './GridContainer.styles';

export const gridMargins: { [K in ViewportSize]: number } = {
  [ViewportSize.xs]: 24,
  [ViewportSize.sm]: 40,
  [ViewportSize.md]: 64,
  [ViewportSize.lg]: 80,
  [ViewportSize.xl]: 80,
};

interface GridContainerProps {
  children: React.ReactNode;
  fixed?: boolean;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
  gridProps?: GridProps;
}

export default function GridContainer({
  children,
  fixed,
  wrapperProps,
  gridProps,
}: GridContainerProps) {
  const { classes, cx } = useStyles();

  return (
    <div
      {...wrapperProps}
      className={cx(
        classes.wrapper,
        { [classes.fixed]: fixed },
        wrapperProps?.className
      )}
    >
      <Grid
        container
        spacing={{ xs: 2, sm: 3, lg: 4 }}
        rowSpacing={'0px'}
        {...gridProps}
      >
        {children}
      </Grid>
    </div>
  );
}
